<script lang="ts" setup>
defineOptions({
  name: 'WaveComponent',
});
</script>

<template>
  <section class="page-home-waves relative h-232px w-full overflow-hidden before:absolute before:bottom-0 before:z-0 before:block before:h-120px before:w-full before:bg-white before:content-empty -mt-112px">
    <img class="absolute top-140px h-full max-w-[unset] w-6400px -left-3200px" src="@/assets/home/wave/wave-1.png">
    <img class="absolute top-0 h-full max-w-[unset] w-6400px -left-3200px" src="@/assets/home/wave/wave-2.png">
    <img class="absolute top-0 h-full max-w-[unset] w-6400px -left-3200px" src="@/assets/home/wave/wave-3.png">
  </section>
</template>

<style lang="scss" scoped>
.page-home-waves {
  @keyframes transformWave {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(3200px);
    }
  }

  img {
    animation: transformWave 4000ms linear infinite;
  }
}
</style>
